import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Content, {HTMLContent} from '../components/Content';
import PartnerOfferings from '../components/PartnerOfferings';
import NavBar from '../components/NavBar';
import Relatedlogos from '../components/Relatedlogos';


export const PartnersAboutPageTemplate = ({title, content, contentComponent, partnerofferings, heading}) => {
    const PageContent = contentComponent || Content

    return (
        <div>
        <NavBar/>
            <section className="hero is-primary is-bold">
                <div className="hero-body">
                    <div className="container">
                        <div className="columns">
                            <div className="column is-10 is-offset-1">
                                <div className="section">
                                    <h1 className="title">
                                        {title}
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section ">
            <div className="container">
                <div className="section ">
                    <div className="columns">
                        <div className="column">
                            <div className="content">
                                <PartnerOfferings gridItems={partnerofferings.blurbs}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
            <section className="section partners">
                <div className="container">
                    <div className="columns">
                        <div className="column is-10 is-offset-1">
                            <div className="section">
                                <PageContent className="content" content={content}/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section proof">
        <Relatedlogos/>
        </section>
                    <section className="hero is-bold">
            <div className="hero-body">
                <div className="container">
                    <div className="columns is-centered">
                            <div className="section home-content">
                             <div className ="has-text-centered">
                                    <h3 className="has-text-weight-semibold is-size-2 has-text-centered">
                                        {heading}
                                    </h3>
                                </div> 
                                <br/>
                                <div className="buttons is-centered">
                                <a
                                    className="button is-large is-primary"
                                    href="https://signup.commonenergy.us/">
                                    Learn More
                                   
                                </a>  
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </div>
    )
};

PartnersAboutPageTemplate.propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string,
    partnerofferings: PropTypes.shape({
        blurbs: PropTypes.array,
    }),
    contentComponent: PropTypes.func,
};

const PartnersAboutPage = ({data}) => {
    const {markdownRemark: post} = data;

    return (
        <div>
            <Helmet>
                <title>{post.frontmatter.meta_title}</title>
                <meta name="description" content={post.frontmatter.meta_description}/>
            </Helmet>
            <PartnersAboutPageTemplate
                contentComponent={HTMLContent}
                title={post.frontmatter.title}
                partnerofferings={post.frontmatter.partnerofferings}
                heading={post.frontmatter.heading}
                content={post.html}
            />
        </div>

    )
};

PartnersAboutPage.propTypes = {
    data: PropTypes.object.isRequired,
};

export default PartnersAboutPage;

export const partnersAboutPageQuery = graphql`
  query PartnersAboutPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        meta_title
        heading
        meta_description
        partnerofferings {
          blurbs {
            image
            text
            subheader
          }
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/templates/partners-about-page.js